type Question = {
    id: number;
    type: string;
    question?: string;
    options?: string[];
    audio?: string;
    duration?: number;
    answer?: number;
};

type Section = {
    section_title: string;
    category_type?: string;
    questions: Question[];
    section_instruction?: string;
    max_point?:number;
    rubric_id?: string;
};

export function validateExamSections(sections: Section[]): string[] {
    const errors: string[] = [];

    sections.forEach((section, sectionIndex) => {
        if (!section.section_title) {
            errors.push(`Section ${sectionIndex + 1}: section title is required.`);
        }
        // if (!section.category_type || String(section.category_type).trim() === '') {
        //     errors.push(`Section ${sectionIndex + 1}: Category Type is required.`);
        // }

        // Validate questions
        if (Array.isArray(section.questions) && section.questions.length > 0) {
            section.questions.forEach((question, questionIndex) => {
                const { type, question: quesText, options, audio } = question;

                // Common validation for all question types
                if (!type) {
                    errors.push(`Section ${sectionIndex + 1}, Question ${questionIndex + 1}: type is required.`);
                    return; // Skip further checks if type is missing
                }

                switch (type) {
                    case "multipleChoice":
                        if (
                            !quesText ||
                            !options ||
                            options.length === 0 ||
                            options.some((opt) => opt === "")
                        ) {
                            errors.push(
                                `Section ${sectionIndex + 1}, Question ${questionIndex + 1
                                }: All fields (question and options) are required for multiple choice.`
                            );
                        }
                        break;

                    case "essay":
                        if (!quesText) {
                            errors.push(
                                `Section ${sectionIndex + 1}, Question ${questionIndex + 1
                                }: question is required for written response' .`
                            );
                        }
                        break;

                    case "audio":
                        if (!quesText && !audio) {
                            errors.push(
                                `Section ${sectionIndex + 1}, Question ${questionIndex + 1
                                }: Either question or audio is required for audio-recording (also upload your own).`
                            );
                        }
                        break;

                    case "audio_multichoice":
                        if (
                            (!quesText && !audio) ||
                            !options ||
                            options.length === 0 ||
                            options.some((opt) => opt === "")
                        ) {
                            errors.push(
                                `Section ${sectionIndex + 1}, Question ${questionIndex + 1
                                }: audio is required, and all options are required for audio with multichoice.`
                            );
                        }
                        break;

                    case "audio_written_response":
                        if (!quesText && !audio) {
                            errors.push(
                                `Section ${sectionIndex + 1}, Question ${questionIndex + 1
                                }: audio is required for Audio with written response.`
                            );
                        }
                        break;

                    case "trueFalse":
                        if (
                            !quesText ||
                            !options ||
                            options.length !== 2 ||
                            options.some((opt) => opt === "")
                        ) {
                            errors.push(
                                `Section ${sectionIndex + 1}, Question ${questionIndex + 1
                                }: All fields (question and options) are required for true false.`
                            );
                        }
                        break;

                    default:
                        errors.push(
                            `Section ${sectionIndex + 1}, Question ${questionIndex + 1
                            }: Unknown question type '${type}'.`
                        );
                }
            });
        } else {
            errors.push(`Section ${sectionIndex + 1}: questions is reqired.`);
        }
    });

    return errors;
}
